import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 1px;\n  background-color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from '../../utils/styling/styled-components';
var DividerLine = styled.div(_templateObject(), function (props) {
  return props.theme.colors.ivory;
});

var Separator = function Separator(props) {
  return /*#__PURE__*/React.createElement(DividerLine, {
    className: props.className
  });
};

export { Separator };